
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const processSteps = [
  {
    number: '01',
    title: 'Analiza',
    description: 'Szczegółowa analiza wymagań projektu i specyfikacji technicznych',
  },
  {
    number: '02',
    title: 'Projekt',
    description: 'Zaawansowane projektowanie konstrukcji z wykorzystaniem technologii CAD',
  },
  {
    number: '03',
    title: 'Produkcja',
    description: 'Precyzyjna produkcja z wykorzystaniem nowoczesnych maszyn CNC',
  },
  {
    number: '04',
    title: 'Kontrola',
    description: 'Rygorystyczna kontrola jakości na każdym etapie produkcji',
  },
  {
    number: '05',
    title: 'Dostawa',
    description: 'Profesjonalny montaż i uruchomienie konstrukcji na miejscu',
  },
];

export default function ProcessCinematic() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section ref={ref} className="relative py-16 sm:py-24 lg:py-32 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
          className="text-center mb-10 sm:mb-16 lg:mb-20"
        >
          <span
            className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Proces Realizacji
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 sm:mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Od Koncepcji do <span className="text-[#00E5FF]">Realizacji</span>
          </h2>
        </motion.div>

        <div className="relative">
          {/* Desktop center line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#00E5FF] via-[#00E5FF]/50 to-[#00E5FF] hidden md:block"></div>

          {/* Mobile left line */}
          <div className="absolute left-4 sm:left-6 top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#00E5FF] via-[#00E5FF]/50 to-[#00E5FF] md:hidden"></div>

          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              className="relative mb-8 sm:mb-12 md:mb-24"
            >
              {/* Desktop layout */}
              <div className={`hidden md:block ${index % 2 === 0 ? 'md:pr-[50%]' : 'md:pl-[50%]'}`}>
                <div className={`flex items-center gap-8 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  <div className="flex-1">
                    <div className="bg-[#050505] border border-[#00E5FF]/30 p-6 lg:p-8 hover:border-[#00E5FF] transition-all duration-500 group">
                      <div className="flex items-start gap-4 lg:gap-6">
                        <div
                          className="text-4xl lg:text-6xl font-black text-[#00E5FF]/20 group-hover:text-[#00E5FF]/40 transition-colors duration-300"
                          style={{ fontFamily: 'Orbitron, sans-serif' }}
                        >
                          {step.number}
                        </div>
                        <div className="flex-1">
                          <h3
                            className="text-lg lg:text-xl font-bold text-white mb-2 lg:mb-3 leading-tight"
                            style={{ fontFamily: 'Rajdhani, sans-serif' }}
                          >
                            {step.title}
                          </h3>
                          <p
                            className="text-[#C0C7CF] text-xs lg:text-sm leading-relaxed"
                            style={{ fontFamily: 'Inter, sans-serif' }}
                          >
                            {step.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-5 h-5">
                  <div className="w-4 h-4 bg-[#00E5FF] rounded-full border-4 border-[#111111]"></div>
                </div>
              </div>

              {/* Mobile layout */}
              <div className="md:hidden flex gap-4 sm:gap-6 pl-10 sm:pl-14">
                <div className="absolute left-4 sm:left-6 top-1 -translate-x-1/2">
                  <div className="w-3 h-3 sm:w-4 sm:h-4 bg-[#00E5FF] rounded-full border-[3px] border-[#111111] shadow-[0_0_10px_rgba(0,229,255,0.4)]"></div>
                </div>
                <div className="bg-[#050505] border border-[#00E5FF]/30 p-4 sm:p-5 flex-1 group">
                  <div className="flex items-start gap-3">
                    <div
                      className="text-2xl sm:text-3xl font-black text-[#00E5FF]/30"
                      style={{ fontFamily: 'Orbitron, sans-serif' }}
                    >
                      {step.number}
                    </div>
                    <div className="flex-1">
                      <h3
                        className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2 leading-tight"
                        style={{ fontFamily: 'Rajdhani, sans-serif' }}
                      >
                        {step.title}
                      </h3>
                      <p
                        className="text-[#C0C7CF] text-xs sm:text-sm leading-relaxed"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
